import { connect } from 'react-redux'
import { crudListStyle } from '../../../styles'
import { ratingsActions, searchTableActions } from '../../../actions'
import { withStyles } from '@material-ui/core/styles'
import IconButton from '@material-ui/core/IconButton'
import { Link } from 'react-router-dom'
import CrudHeader from '../../../components/CrudHeader'
import Layout from '../../../components/Layout'
import ListTable from './ListTable'
import React, { Component } from 'react'
import UserToolbar from '../../../components/UserToolbar'
import EditModal from './EditModal'
import classNames from 'classnames'
import Paper from '@material-ui/core/Paper'
import BackButton from 'material-ui/svg-icons/hardware/keyboard-arrow-left'

class RatingDetails extends Component {
  render() {
    const { modalOpen, openModal, closeModal, classes, token, router, title } = this.props

    const {
      match: {
        params: { id: ratingId }
      }
    } = router

    return (
      <Layout toolBarRight={UserToolbar}>
        <CrudHeader
          title={'Avaliações do conteúdo'}
          classes={classes}
          token={token}
          functionality={'avaliacoes'}
          displayCreateButton={false}
        />

        <Paper
          style={{
            padding: '8px 18px',
            display: 'flex',
            borderRadius: '4px 4px 0 0',
            alignItems: 'center'
          }}
          elevation={5}
        >
          <IconButton
            component={Link}
            to={(router.location.state || {}).back || '/avaliacoes'}
            color="default"
            variant={'contained'}
            size={'small'}
            style={{ marginRight: 10 }}
            className={classNames(classes.actionBarButton, classes.backButton)}
          >
            <BackButton />
          </IconButton>
          <div
            style={{
              flex: 1,
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis'
            }}
          >
            {title}
          </div>
        </Paper>
        <ListTable ratingId={ratingId} />
        <EditModal open={modalOpen} onClose={closeModal} contentName={title} />
      </Layout>
    )
  }
}

const mapStateToProps = state => {
  return {
    title: state.ratings.details.contentTitle,
    modalOpen: state.ratings.modalOpen,
    token: state.auth.token
  }
}

const mapDispatchToProps = dispatch => {
  return {
    openModal: () => {
      dispatch(ratingsActions.openModal())
    },
    closeModal: () => {
      dispatch(ratingsActions.closeModal())
    },
    fetchDetails: id => {
      dispatch(ratingsActions.fetchDetails(id))
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(crudListStyle)(RatingDetails))



// WEBPACK FOOTER //
// ./src/containers/Ratings/RatingDetails/index.js